import getPrice from './getPrice';
import getBadge, { getFirstValidBadge } from './getBadges';
import getProductLinkByPartNumber from './getProductLinkByPartNumber';
import getProductImage from './getProductImage';
import getAttribute from './getAttribute';
import { getGenderFromAttributes } from './getGender';

export default function getMappedProduct({
    id,
    product = {},
    badgeBlocklist,
    locale,
    availableImageSizes,
    pdpUrlTemplate,
    imageQuality,
    pageType,
    messages,
    saleBadges,
    imagesphereAspectRatio,
    consideredBadge,
    plpImageSrcSet,
    user,
}) {
    const {
        designerName = '',
        designerNameEN = '',
        designerIdentifier = '',
        name,
        nameEN,
        price,
        badges,
        partNumber,
        masterCategory = {},
        seo,
        attributes = [],
        onSale = false,
        tracking = {},
        preOrder = false,
        shortDescription,
    } = product;

    const {
        label: primaryCategory = '',
        labelEN: primaryCategoryEN = '',
        categoryId: primaryCategoryId = '',
        child: {
            label: subCategory1 = '',
            labelEN: subCategory1EN = '',
            categoryId: subCategory1Id = '',
            child: { label: subCategory2 = '', labelEN: subCategory2EN = '', categoryId: subCategory2Id = '' } = {},
        } = {},
    } = masterCategory || {};

    const analyticsAttributes = {
        season: getAttribute(attributes, 'Sale Season'),
        department: getAttribute(attributes, 'Department'),
        colour: getAttribute(attributes, 'Brand Colour'),
        badge: getFirstValidBadge(badges, badgeBlocklist),
        nameEN: nameEN || tracking?.name, //nameEN for PLP and tracking?.name for PDP
        designerNameEN,
        preOrder,
        category: {
            primaryCategory: primaryCategoryEN || primaryCategory,
            subCategory1: subCategory1EN || subCategory1,
            subCategory2: subCategory2EN || subCategory2,
            ids: [primaryCategoryId, subCategory1Id, subCategory2Id],
        },
        gender: getGenderFromAttributes(attributes),
    };

    const selectedProductColour = product.productColours?.find((c) => c.selected) || product.productColours?.[0] || product;
    const productSeo = selectedProductColour?.seo || seo;
    return {
        productId: id,
        designerName: designerNameEN ? designerNameEN : designerName,
        designerIdentifier,
        name: shortDescription || name || nameEN,
        price: getPrice(price, 'rdSellingPrice'),
        onSale,
        badge:
            getBadge({
                badges,
                badgeBlocklist,
                pageType,
                messages,
                options: { onSale, configSaleBadges: saleBadges },
                user,
                segmentBadges: selectedProductColour.segmentBadges,
            }) || null,
        imgSrc: getProductImage(product, availableImageSizes, imageQuality, 0, imagesphereAspectRatio, plpImageSrcSet),
        href: getProductLinkByPartNumber(pdpUrlTemplate, locale, productSeo, selectedProductColour.partNumber),
        partNumber,
        masterCategory,
        analyticsAttributes,
        consideredBadge,
        hasSiblings: product.hasSiblings,
        productSiblings: product.productSiblings,
        modelId: product.modelId,
        notStockedOnline: !!product.notStockedOnline,
        colour: selectedProductColour?.label,
    };
}
